export const TEXTS = {
	form: {
		labels: {
			deposit: {
				text: 'Initial deposit'
			},
			contribution: {
				text: 'Annual contribution'
			},
			years: {
				text: 'Years'
			},
			rate: {
				text: 'Estimated interest'
			}
		},

		inputs: {
			errors: {
				required: 'Required',
				type: 'Must be a number',
				min: 'The minimum value is 0',
				max: 'The maximum value is 1'
			}
		},

		submit: {
			text: 'Calculate'
		}
	},

	result: {
		text: 'Final balance:'
	}
};
